{
  "name": "admin",
  "version": "1.28.5",
  "browser": {
    "fs": false,
    "path": false,
    "os": false
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port=8200 --open --host 0.0.0.0 --disable-host-check ",
    "build": "ng build --configuration=production --aot=true --optimization=true",
    "build:stag": "ng build --configuration=stag --aot=true --optimization=true",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "sonar": "sonar-scanner",
    "update-angular": "ng update @angular/core @angular/cli @angular/cdk @angular-devkit/build-angular @angular/compiler-cli @angular/material",
    "changelog-version": "node generate-changelog-update-version.js",
    "commit-version": "git add . && git commit -m'Version name: '$(grep -m1 version package.json | awk -F: '{ print $2 }' | sed 's/[\", ]//g')''",
    "release": "npm run changelog-version && npm run commit-version && git push && git checkout main && git pull  && git merge --no-ff dev && git push && git checkout -",
    "release-without-rollout": "npm run changelog-version && npm run commit-version && git push && git checkout main && git pull",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org mar-saude --project admin dist/admin/browser && sentry-cli sourcemaps upload --org mar-saude --project admin dist/admin/browser"
  },
  "private": true,
  "dependencies": {
    "@ag-grid-community/locale": "^34.2.0",
    "@amplitude/analytics-browser": "^2.17.5",
    "@angular/animations": "^19.2.10",
    "@angular/cdk": "^19.2.15",
    "@angular/common": "^19.2.10",
    "@angular/compiler": "^19.2.10",
    "@angular/core": "^19.2.10",
    "@angular/forms": "^19.2.10",
    "@angular/material": "^19.2.15",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.10",
    "@angular/platform-browser-dynamic": "^19.2.10",
    "@angular/router": "^19.2.10",
    "@mescius/wijmo.angular2.grid": "^5.20251.40",
    "@mescius/wijmo.angular2.grid.filter": "^5.20251.40",
    "@mescius/wijmo.angular2.grid.grouppanel": "^5.20251.40",
    "@mescius/wijmo.angular2.grid.search": "^5.20251.40",
    "@mescius/wijmo.angular2.input": "^5.20251.40",
    "@mescius/wijmo.cultures": "^5.20251.40",
    "@mescius/wijmo.grid.filter": "^5.20251.40",
    "@mescius/wijmo.grid.pdf": "^5.20251.40",
    "@mescius/wijmo.grid.xlsx": "^5.20251.40",
    "@ngx-formly/core": "^6.3.12",
    "@ngx-formly/material": "^6.3.12",
    "@sentry/angular": "^9.19.0",
    "@sentry/cli": "^2.45.0",
    "@webcoder49/code-input": "^2.2.1",
    "ag-grid-angular": "^34.2.0",
    "ag-grid-community": "^34.2.0",
    "ag-grid-enterprise": "^34.2.0",
    "angular-cd-timer": "^3.0.0",
    "angular-imask": "^7.6.1",
    "dayjs": "^1.11.13",
    "fflate": "^0.8.2",
    "flatpickr": "^4.6.13",
    "highlight.js": "^11.10.0",
    "iframe-resizer": "^4.3.11",
    "json-logic-js": "^2.0.5",
    "jszip": "^3.10.1",
    "marked": "^15.0.7",
    "ng2-currency-mask": "^13.0.3",
    "ngx-file-drop": "^16.0.0",
    "ngx-image-cropper": "^8.0.0",
    "numeral": "^2.0.6",
    "pdfjs-dist": "^4.10.38",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0",
    "zstd-codec": "^0.1.5"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.12",
    "@angular/cli": "^19.2.12",
    "@angular/compiler-cli": "^19.2.10",
    "@types/jasmine": "~5.1.0",
    "@types/numeral": "^2.0.5",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "semver": "^7.6.3",
    "sonar-scanner": "^3.1.0",
    "typescript": "~5.8.3"
  }
}